import { Redirect, useLocation } from 'react-router'

import { RouteName } from './RouteName'

/**
 * 매치되는 라우트가 없을 때 로그인으로 보내는 폴백.
 * `to` 에 문자열을 주면 react-router 가 현재 search·hash 를 버린다. 앱 진입 URL 의 쿼리
 * (promo·version·device)를 로그인 화면에서 읽는 분기가 있으므로 그대로 승계한다.
 */
const LoginFallbackRedirect = () => {
  const { search, hash } = useLocation()

  return <Redirect to={{ pathname: RouteName.login, search, hash }} />
}

export default LoginFallbackRedirect
